module.exports = __webpack_public_path__ + "img/升麻.8dc3a609.jpg";